import React, { useEffect, useState, useCallback, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../dropdown'
import DropZone from '../../dropzone';
import { FormSelectYesNo,  FormInputText, DateSelector, FormTextArea } from '../formelements'
import { ContacteEmergencia } from './contacteEmergencia'
//import { useDropzone } from 'react-dropzone'
import axios from 'axios';
import config from '../../../config'



export function EnrolmentFormPersonalData(props) {

  /* DADES GENERALS */
  const [ errors, setErrors ] = useState({});
  const [ errorValidacioIDdocument, setErrorValidacioIDdocument ] = useState();

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  const [dadesPersonals, setDadesPersonals ] = useState({validat: false});
  // gent que faci els 12 dins l'any - 1r ESO
  const any_12 = new Date().getFullYear() - 12
  let maxDate = new Date(any_12 + "-12-31")

  let minDate = new Date("1950-1-1")

  /* DADES PERSONALS */
  const [dadesIdentificativesOpen, setDadesIdentificativesOpen] = useState(true)
  const toggleOpen = () => {

    // si passa de tancat a obert invalidem apartats següents
      console.log("DIO 1",dadesIdentificativesOpen)
    if(!dadesIdentificativesOpen)
    {
      console.log("DIO 2",dadesIdentificativesOpen)
        setDadesPersonals(false)
        handleDadesPersonals(false)

        handleDadesMediques(false)
        setDadesMediquesOpen(false)
        setDadesMediques(false)

        handleDadesLaborals(false)
        setDadesLaboralsOpen(false)
        setDadesLaborals(false)
    }

    setDadesIdentificativesOpen(!dadesIdentificativesOpen)
  }

  const [nom, setNom] = useState('');
  const [cognom1, setCognom1] = useState('');
  const [cognom2, setCognom2] = useState('');
  const [tipusDoc, setTipusDoc] = useState('DNI');
  const [iddocument, setIDDocument] = useState('');
  const [iddocumentFrontFile, setIDDocumentFrontFile] = useState();
  const [iddocumentBackFile, setIDDocumentBackFile] = useState();
  const [fotoCarnetFile, setFotoCarnetFile] = useState();
  const [sexe, setSexe] = useState('');
  const [dataNaixement, setDataNaixement] = useState(maxDate)
  const [majorEdat, setMajorEdat] = useState();
  const [edat, setEdat] = useState();
  const [llibreFamiliaFile, setLlibreFamiliaFile] = useState();
  const [llibreFamiliaAlumneFile, setLlibreFamiliaAlumneFile] = useState();
  const [comunicacioProgenitors, setComunicacioProgenitors] = useState();

  const [progenitor1PM, setProgenitor1PM] = useState('');
  const [progenitor1Nom, setProgenitor1Nom] = useState('');
  const [progenitor1Adreca, setProgenitor1Adreca] = useState('');
  const [progenitor1Municipi, setProgenitor1Municipi] = useState('');
  const [progenitor1CodiPostal, setProgenitor1CodiPostal] = useState('');
  const [progenitor1Provincia, setProgenitor1Provincia] = useState('');
  const [progenitor1Pais, setProgenitor1Pais] = useState('');

  const [progenitor1iddocument, setProgenitor1iddocument] = useState('');
  const [progenitor1IDFrontFile, setProgenitor1IDFrontFile] = useState();
  const [progenitor1IDBackFile, setProgenitor1IDBackFile] = useState();
  const [progenitor1Telefon, setProgenitor1Telefon] = useState('');
  const [progenitor1Email, setProgenitor1Email] = useState('');
  const [progenitor1Observacions, setProgenitor1Observacions] = useState('');

  const [progenitor2PM, setProgenitor2PM] = useState('');
  const [progenitor2Nom, setProgenitor2Nom] = useState();
  const [progenitor2Adreca, setProgenitor2Adreca] = useState('');
  const [progenitor2Municipi, setProgenitor2Municipi] = useState('');
  const [progenitor2CodiPostal, setProgenitor2CodiPostal] = useState('');
  const [progenitor2Provincia, setProgenitor2Provincia] = useState('');
  const [progenitor2Pais, setProgenitor2Pais] = useState('');
  const [progenitor2iddocument, setProgenitor2iddocument] = useState();
  const [progenitor2IDFrontFile, setProgenitor2IDFrontFile] = useState();
  const [progenitor2IDBackFile, setProgenitor2IDBackFile] = useState();
  const [progenitor2Telefon, setProgenitor2Telefon] = useState();
  const [progenitor2Email, setProgenitor2Email] = useState('');
  const [progenitor2Observacions, setProgenitor2Observacions] = useState();

  const [contacteEmergenciaNom, setContacteEmergenciaNom] = useState('');
  const [contacteEmergenciaRelacio, setContacteEmergenciaRelacio] = useState();
  const [contacteEmergenciaTelefon, setContacteEmergenciaTelefon] = useState('');

  const [adreca, setAdreca] = useState('');
  const [adrecaVia, setAdrecaVia] = useState('Carrer');
  const [adrecaNom, setAdrecaNom] = useState('');
  const [adrecaNumero, setAdrecaNumero] = useState('');
  const [adrecaBloc, setAdrecaBloc] = useState('');
  const [adrecaEscala, setAdrecaEscala] = useState('');
  const [adrecaPlanta, setAdrecaPlanta] = useState('');
  const [adrecaPorta, setAdrecaPorta] = useState('');

  const [codiPostal, setCodiPostal] = useState('');
  const [poblacio, setPoblacio] = useState('');
  const [provincia, setProvincia] = useState('');
  const [pais, setPais] = useState('Espanya');
  const [telefonFix, setTelefonFix] = useState('');
  const [telefonMobil, setTelefonMobil] = useState('');

  const [telefonFixObligatori, setTelefonFixObligatori] = useState(false);
  const [telefonMobilObligatori, setTelefonMobilObligatori] = useState(false);

  const [email, setEmail] = useState('');

  const [cursObligatori, setCursObligatori ] = useState();
  const [tornObligatori, setTornObligatori ] = useState();
  const [becat, setBecat] = useState();

  const [necessitatsEducativesEspecialsFile, setNecessitatsEducativesEspecialsFile] = useState();
  const [necessitatsEducativesEspecialsObservacions, setNecessitatsEducativesEspecialsObservacions] = useState();

  const handleBlurIDDocument = (e) => 
  {
    //let error = {};

    //TODO error.iddocument = validaIDDocument(e);

    validaIDDocument(e);

    //console.log("blur ID",error, e);
    //console.log("blur ID", e);

    return true;
  }


  /* DADES MEDIQUES */
  const [dadesMediquesOpen, setDadesMediquesOpen] = useState(false);
  const toggleDadesMediquesOpen = () => {
    setDadesMediquesOpen(!dadesMediquesOpen);
  }

  const [dadesMediques, setDadesMediques] = useState({validat: false});

  /* VALIDA DADES PERSONALS */
  const validaNom = () => {
    return nom.length > 0 ? null : "El nom no pot estar buit"
  }

  const validaCognom1 = () => {
    return cognom1.length > 0 ? null : "El camp Primer Cognom no pot estar buit"
  }

  const validaSexe = () => {
    return sexe.length > 0 ? null : "Heu d'indicar un sexe"
  }

  const validaStringNoBuit = (camp, errormsg) => {
    return camp.length > 0 ? null : errormsg;
  }

  const validaAdrecaNumero = () => {
    return validaStringNoBuit(adrecaNumero, "El camp número no pot estar buit");
  }

  const validaAdrecaNom = () => {
    return validaStringNoBuit(adrecaNom, "El camp adreça no pot estar buit");
  }

  const validaAdreca = () => {
    return validaStringNoBuit(adreca, "El camp adreça no pot estar buit");
  }

  const validaCodiPostal = () => {
    return validaStringNoBuit(codiPostal, "El camp codi postal no pot estar buit");
  }

  const validaPoblacio = () => {
    return validaStringNoBuit(poblacio, "El camp població no pot estar buit");
  }

  const validaProvincia = () => {
    return validaStringNoBuit(provincia, "El camp provincia no pot estar buit");
  }

  const validaPais = () => {
    return validaStringNoBuit(pais, "El camp país no pot estar buit");
  }

  const validaIDDocumentDB = async (d) => {

  try 
   {

    const dadesPost = {
      cid: config.cid,
      act: 'chkiddoc',
      iddocument: d,
    }

    const headers = { 'Content-Type': 'multipart/form-data' }

      //axios.post(config.apiURL, dadesPost, headers)
      const response = await axios.post("/api/", dadesPost, headers);

      // si amb el DNI hi ha torn i curs obligatori els posem per a forcar la tria
      if(response.data.t) { setTornObligatori(response.data.t)} else { setTornObligatori()}
      if(response.data.c) { setCursObligatori(response.data.c)} else { setCursObligatori() }
      if(response.data.b) { setBecat(response.data.b)} else { setBecat()}

      console.log("becat",becat)

      setErrorValidacioIDdocument(response.data.r === 1 ? null : "Document no trobat al llistat de matriculables. Contacteu amb secretaria.")
      return false
    }
    catch (err) {
      //console.log(err)
      return false;
    };
    
  }


  const handleTelefonObligatori = ()  => {

    //console.log("TEL OBL")

    if(majorEdat) { 
      //setTelefonFixObligatori(true)
      setTelefonMobilObligatori(true)

    //console.log("TEL OBL","MAJOR EDAT SI")

      // Si han omplert una de les dues l'altra no és obligatori
      /*
      if( telefonFix.length )
      {
        setTelefonMobilObligatori(false)
    //console.log("TEL OBL","FIX PLE MOB OPT")
      }

      if( telefonMobil.length )
      {
        setTelefonFixObligatori(false)
    //console.log("TEL OBL","MOBIL PLE FIX OPT")
      }

    */

    } else {

    //console.log("TEL OBL","MAJOR EDAT NO")
      setTelefonMobilObligatori(false)
      //setTelefonFixObligatori(false)
    }

  }


  const handleTelefonFix = (e) => {

    setTelefonFix(e)

  }

  const handleTelefonMobil= (e) => {

    setTelefonMobil(e)

  }

  useEffect(() => {

    // telefon obligatori per majors edat
    handleTelefonObligatori()

  }, [dataNaixement,telefonFix,telefonMobil])




  const validaIDDocument = (e) => {

      let error = {}
      // si tornem a comprovar eliminem error prèvi
    if (config.validaIDdocuments) {
      setErrorValidacioIDdocument("")
    }

  //console.log(":: -1",e)

    let d;

    if(e)
    {
      d = e.toUpperCase()
    }
    else
    {
      d = iddocument.toUpperCase()
    }

    
    if(!d.length > 0)
    {
      return "El camp no pot estar buit."
    }
    
    setIDDocument(d)

    if (tipusDoc === "DNI") {
      if(!/^[0-9]{8}[A-Z]$/.test(d)) 
      {
        return "El format de DNI no és vàlid."
      }
    }

    if (config.validaIDdocuments) {
      validaIDDocumentDB(d)
    }

    return null
  }

  const validaIDDocumentFrontFile = () => {

    return iddocumentFrontFile ? null : "El camp no pot estar buit."
  }

  const validaIDDocumentBackFile = () => {

    return iddocumentBackFile ? null : "El camp no pot estar buit."
  }

  const validaFotoCarnetFile = () => {

    // si no cal foto carnet valida sempre
    if(!config.fotoCarnet) return null

    return fotoCarnetFile ? null : "El camp no pot estar buit."
  }

  const validaLlibreFamiliaFile  = () => {

    return llibreFamiliaFile ? null : "Heu d'adjuntar un document"
  }

  const validaLlibreFamiliaAlumneFile  = () => {

    return llibreFamiliaAlumneFile ? null : "Heu d'adjuntar un document"
  }

  const validaProgenitor1PM= () => {
    return progenitor1PM ? null : "Heu de triar una opció"
  }

  const validaProgenitor1Nom = () => {
    return progenitor1Nom.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1Adreca= () => {
    return progenitor1Adreca.length > 0 ? null : "El nom no pot estar buit"
  }

  const validaProgenitor1Municipi = () => {
    return progenitor1Municipi.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1CodiPostal = () => {
    return progenitor1CodiPostal.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1Provincia= () => {
    return progenitor1Provincia.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1Pais= () => {
    return progenitor1Pais.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1iddocument= () => {
    return progenitor1iddocument.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1FrontFile = () => {

    return progenitor1IDFrontFile ? null : "El camp no pot estar buit."
  }

  const validaProgenitor1BackFile = () => {

    return progenitor1IDBackFile ? null : "El camp no pot estar buit."
  }

  const validaProgenitor1Telefon = () => {
    return progenitor1Telefon.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1Email = () => {
      return validaEmail(progenitor1Email);
    //return progenitor1Email.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1Observacions = () => {
    return progenitor1Observacions.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor2Nom = () => {
    return progenitor2Nom.length > 0 ? null : "El nom no pot estar buit"
  }

  const validaProgenitor2Adreca= () => {
    return progenitor2Adreca.length > 0 ? null : "El nom no pot estar buit"
  }

  const validaProgenitor2Municipi = () => {
    return progenitor2Municipi.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor2CodiPostal= () => {
    return progenitor2CodiPostal.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor2Provincia= () => {
    return progenitor2Provincia.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor2Pais= () => {
    return progenitor2Pais.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor2Telefon = () => {
    return progenitor2Telefon.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor2Email = () => {

     // no obligatori pero si l'han posat comprovem format correcte
    if(progenitor2Email.length)
    {
      return validaEmail(progenitor2Email);
    }

    return null
  }

  const validaProgenitor2Observacions = () => {
    return progenitor2Observacions.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaComunicacioProgenitors = () => {
    if (majorEdat) {
      return comunicacioProgenitors ? null : "Cal triar un valor"
    }

    return null
  }

  const validaContacteEmergenciaNom = () => {
    return contacteEmergenciaNom.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaContacteEmergenciaRelacio = () => {
      return contacteEmergenciaRelacio ? null : "Cal triar un valor"
  }

  const validaContacteEmergenciaTelefon = () => {
    return contacteEmergenciaTelefon.length > 0 ? null : "El camp no pot estar buit"
  }


  const validaTelefons = () => {

    if(!config.telefonObligatori) return null

    if (majorEdat) {

      if( !telefonFix.length && !telefonMobil.length )
      {
        return "S'ha de proporcionar al menys un telèfon"
      }
    }

    return null
  }

  const validaEmail = (e) => {

      if(!e.length)
      {
          return "El camp email no pot estar buit"
      }

      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if(!pattern.test(e))
      {
       return "No és un format d'email vàlid"
      }

    return null
  }



  const valida = (e) => {

    e.preventDefault();

    handleTelefonObligatori()

    let error = {}

    // abans de validar eliminem errors anteriors
    setErrors(error)

    //TODO ERROR
    error.iddocument = validaIDDocument()

    handleErrors('iddocument', error)

    error.nom = validaNom();

    handleErrors('nom', validaNom())

    error.cognom1 = validaCognom1();

    handleErrors('cognom1', error)

    handleErrors('dataNaixement', validaDataNaixement())

    error.telefon = validaTelefons();
    handleErrors('telefon', error)

    //if (majorEdat || email.length) {
    if (email.length) {
      error.email = validaEmail(email);
      handleErrors('email', error)
  }

    error.pais = validaPais();

    handleErrors('pais', error)

    error.provincia = validaProvincia();

    handleErrors('provincia', error)

    error.poblacio = validaPoblacio();

    handleErrors('poblacio', error)

    error.codiPostal = validaCodiPostal();

    handleErrors('codiPostal', error)

    error.adrecaNom = validaAdrecaNom();
    handleErrors('adrecaNom', error)

    error.adrecaNumero = validaAdrecaNumero();
    handleErrors('adrecaNumero', error)

    setAdreca(adrecaVia+" "+adrecaNom+" "+adrecaNumero+" "+adrecaBloc+" "+adrecaEscala+" "+adrecaNumero+" "+adrecaPlanta+" "+adrecaPorta)

    error.adreca = validaAdreca();
    handleErrors('adreca', error)

    //errors.tipusDoc = validaTipusDoc(tipusDoc)


    if ( tipusDoc !== "PRE") {

      error.iddocumentFrontFile = validaIDDocumentFrontFile()

      handleErrors('iddocumentFrontFile', error)

      error.iddocumentBackFile = validaIDDocumentBackFile()
    }

    if (config.fotoCarnet) {
    handleErrors('fotoCarnetFile', error)

    error.fotoCarnetFile = validaFotoCarnetFile()
    }

    handleErrors('iddocumentBackFile', error)

    error.sexe = validaSexe(sexe)


    //console.log("CONTACTE",config.contacteEmergenciaObligatori)

    if ( config.contacteEmergenciaObligatori && majorEdat ) {

      error.contacteEmergenciaNom = validaContacteEmergenciaNom()
      handleErrors('contacteEmergenciaNom', error)

      error.contacteEmergenciaRelacio = validaContacteEmergenciaRelacio()
      handleErrors('contacteEmergenciaRelacio', error)

      error.contacteEmergenciaTelefon = validaContacteEmergenciaTelefon()
      handleErrors('contacteEmergenciaTelefon', error)

    }


    if (majorEdat) {

      error.comunicacioProgenitors = validaComunicacioProgenitors()

      handleErrors('comunicacioProgenitors', error)

    }
    else {

        error.llibreFamiliaFile = validaLlibreFamiliaFile()
        handleErrors('llibreFamiliaFile', error)

        error.llibreFamiliaAlumneFile = validaLlibreFamiliaAlumneFile()
        handleErrors('llibreFamiliaAlumneFile', error)

        error.progenitor1PM = validaProgenitor1PM()
        handleErrors('progenitor1PM', error)

        error.progenitor1Nom = validaProgenitor1Nom()
        handleErrors('progenitor1Nom', error)

        error.progenitor1Adreca = validaProgenitor1Adreca()
        handleErrors('progenitor1Adreca', error)

        error.progenitor1Municipi = validaProgenitor1Municipi()
        handleErrors('progenitor1Municipi', error)

        error.progenitor1CodiPostal = validaProgenitor1CodiPostal()
        handleErrors('progenitor1CodiPostal', error)

        error.progenitor1Provincia = validaProgenitor1Provincia()
        handleErrors('progenitor1Provincia', error)

        error.progenitor1Pais = validaProgenitor1Pais()
        handleErrors('progenitor1Pais', error)

        error.progenitor1iddocument= validaProgenitor1iddocument()
        handleErrors('progenitor1iddocument', error)

        error.progenitor1IDFrontFile = validaProgenitor1FrontFile()
        handleErrors('progenitor1IDFrontFile', error)

        error.progenitor1IDBackFile = validaProgenitor1BackFile()
        handleErrors('progenitor1IDBackFile', error)

        error.progenitor1Telefon = validaProgenitor1Telefon()
        handleErrors('progenitor1Telefon', error)

        error.progenitor1Email = validaProgenitor1Email()
        handleErrors('progenitor1Email', error)

        //error.progenitor1Observacions = validaProgenitor1Observacions()
        //handleErrors('progenitor1Observacions', error)

        //error.progenitor2Email = validaProgenitor2Email()
        //handleErrors('progenitor2Email', error)

      }

    setErrors(error)

    //console.log('errors', errors)

    let noError = true;
    //DEVELOP if (window.location.hostname !== "localhost" ) 
    if(!config.develop) // bypass errors if develop == true
    {
     Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
    }

    handleDadesPersonals(noError)

    if(noError)
    {

        if(!config.develop){ // bypass errors if develop == true
          if (config.validaIDdocuments) {
            //console.log("VALIDA",errorValidacioIDdocument);
              if(errorValidacioIDdocument !== null ) { 
              // console.log("NO VALIDAT"); 
                return false;}
          }
        }

      console.log("VALIDAT",noError,error)

        setDadesIdentificativesOpen(false)
        setDadesMediquesOpen(true)
        setDadesLaboralsOpen(false)
        if(edat<16)
        {
          handleDadesLaborals(true)
        }
    }

    return false;
  }


  const handleFileError = (e,msg) => {
    let err  = {...errors}
    err[e] = msg 
    setErrors(err)
  }

   const getShortAttribute = (ref,valueToFind) => {
     if (ref.current) {
       for (let i = 0; ref.current[i].value ; i++) {
         if (ref.current[i].value === valueToFind) {
           return ref.current[i].getAttribute('short');
         }
       }
     }
    return null;
  };


  useEffect(() => {

    let error = {}

    //console.log("DATA_NAIXE")

    //console.log('valida data naixement')
    error.dataNaixement = validaDataNaixement();

    handleErrors('dataNaixement', error)

    let dadesPersonals = { ...props.dadesPersonals }

    dadesPersonals.dataNaixement = dataNaixement;

    props.handleDadesPersonals(dadesPersonals)

  }, [dataNaixement])


  const handleDadesPersonals = (noError) => {

  let d = {
  "validat": noError,
  "nom": nom , 
  "cognom1": cognom1 , 
  "cognom2": cognom2 , 
  "tipusDoc": tipusDoc , 
  "iddocument": iddocument , 
  "iddocumentFrontFile": iddocumentFrontFile , 
  "iddocumentBackFile": iddocumentBackFile , 
  "fotoCarnetFile": fotoCarnetFile, 
  "sexe": sexe , 
  "dataNaixement": dataNaixement , 
  "majorEdat": majorEdat , 
  "edat": edat, 
  "llibreFamiliaFile": llibreFamiliaFile , 
  "llibreFamiliaAlumneFile": llibreFamiliaAlumneFile , 
  "comunicacioProgenitors": comunicacioProgenitors , 

  "progenitor1PM": progenitor1PM, 
  "progenitor1Nom": progenitor1Nom , 
  "progenitor1Adreca": progenitor1Adreca, 
  "progenitor1Municipi": progenitor1Municipi, 
  "progenitor1CodiPostal": progenitor1CodiPostal, 
  "progenitor1Provincia": progenitor1Provincia, 
  "progenitor1Pais": progenitor1Pais, 
  "progenitor1iddocument": progenitor1iddocument, 
  "progenitor1IDFrontFile": progenitor1IDFrontFile , 
  "progenitor1IDBackFile": progenitor1IDBackFile , 
  "progenitor1Telefon": progenitor1Telefon , 
  "progenitor1Email": progenitor1Email , 
  "progenitor1Observacions": progenitor1Observacions , 

  "progenitor2PM": progenitor2PM, 
  "progenitor2Nom": progenitor2Nom , 
  "progenitor2Adreca": progenitor2Adreca, 
  "progenitor2Municipi": progenitor2Municipi, 
  "progenitor2CodiPostal": progenitor2CodiPostal, 
  "progenitor2Provincia": progenitor2Provincia, 
  "progenitor2Pais": progenitor2Pais, 
  "progenitor2iddocument": progenitor2iddocument, 
  "progenitor2IDFrontFile": progenitor2IDFrontFile , 
  "progenitor2IDBackFile": progenitor2IDBackFile , 
  "progenitor2Telefon": progenitor2Telefon , 
  "progenitor2Email": progenitor2Email , 
  "progenitor2Observacions": progenitor2Observacions , 

  //"contacteEmergenciaNom": contacteEmergenciaNom , 
  //"contacteEmergenciaRelacio": contacteEmergenciaRelacio , 
  //"contacteEmergenciaTelefon": contacteEmergenciaTelefon , 

  "adreca": adreca , 
  "adrecaVia": adrecaVia , 
  "adrecaNom": adrecaNom , 
  "adrecaBloc": adrecaBloc , 
  "adrecaNumero": adrecaNumero , 
  "adrecaEscala": adrecaEscala , 
  "adrecaPlanta": adrecaPlanta , 
  "adrecaPorta": adrecaPorta , 

  "codiPostal": codiPostal , 
  "poblacio": poblacio , 
  "provincia": provincia , 
  "pais": pais , 
  "telefonFix": telefonFix , 
  "telefonMobil": telefonMobil , 
  "email": email, 

  "tornObligatori": tornObligatori, 
  "cursObligatori": cursObligatori, 
  "becat": becat, 

  "necessitatsEducativesEspecialsFile": necessitatsEducativesEspecialsFile,
  "necessitatsEducativesEspecialsObservacions": necessitatsEducativesEspecialsObservacions
  }

    //console.log("DADES_PERSONALS",d)
    setDadesPersonals(d)
    props.handleDadesPersonals(d)
  }


  /* DADES MEDIQUES */

  const handleDadesMediques = (noError) => {

  let d = { "validat": noError }

    //console.log("DADES_MEDIQUES",d)
    setDadesMediques(d)
    props.handleDadesMediques(d)
  }


// VALIDA 

  const calculaEdat = (dataNaixement) => {
        const birthDate = new Date(dataNaixement);
        const currentDate = new Date();
    
        let edat = currentDate.getFullYear() - birthDate.getFullYear();

        const monthDifference = currentDate.getMonth() - birthDate.getMonth();

        //console.log("EDAT CALC",monthDifference,edat,currentDate.getFullYear(),birthDate.getFullYear())
        if (
          monthDifference < 0 ||
          (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())
        ) {
          edat--;
        }
    
        //console.log("EDAT CALC 4",edat);
        return edat;
  }


  /* DADES LABORALS */
  const [dadesLaboralsOpen, setDadesLaboralsOpen] = useState(false);
  const toggleDadesLaboralsOpen = () => {
    setDadesLaboralsOpen(!dadesLaboralsOpen);
  }
  const [dadesLaborals, setDadesLaborals] = useState({validat: false});

  const handleDadesLaborals = (noError) => {

  let d = {  "validat": noError }

    setDadesLaborals(d)
    props.handleDadesLaborals(d)
  }




  const validaDataNaixement = () => {
    //let temps = new Date(dataNaixement)


    if (dataNaixement) 
    {
      const edatCalc = calculaEdat(dataNaixement)

    //console.log("VALIDA DATA_NAIXE",dataNaixement,edatCalc,edatCalc >= 18)

      setEdat( edatCalc )

      setMajorEdat(edatCalc >= 18)

      if(edatCalc<16)
      {
       handleDadesLaborals(true)
      }

     // temps.setFullYear(temps.getFullYear() + 18) // 18 anys
     //setMajorEdat(new Date().getTime() >= temps.getTime())

    //console.log("EDAT",edat,edatCalc,majorEdat)
    }

    // data ok
    return null;
    // return /^[0-3][0-9]\/[0-1][0-9]\/[0-9]{4}$/.test(dataNaixement) ? null : "El format de la data no és vàlid."
  }

  const tipusDocRef = useRef(null);

  return (

    <div className="container">
      <div className="row">
        <div className="col col-12 ">
            { config.pagamentTPV && ( dadesIdentificativesOpen && (
            <div style={{ textAlign: 'center', fontSize: '1.05rem'}}>Si ja heu realitzat la inscripció prèviament i només voleu realitzar el pagament podeu accedir-hi directament aquí <a href={config.urlTPV}>{config.urlTPV}</a></div>
            ))}
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button className="t-Button t-Button--icon t-Button--hideShow" type="button" onClick={toggleOpen}>
                  {dadesIdentificativesOpen && <FontAwesomeIcon icon={faChevronUp} fontSize="18" className="t-Icon" />}
                  {!dadesIdentificativesOpen && <FontAwesomeIcon icon={faChevronDown} fontSize="18" className="t-Icon" />}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">Dades personals</h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">

              <Dropdown open={dadesIdentificativesOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">

                    <div className="row">
                      <div className="col col-12" >
                          <label className="t-Form-label">Dades de l'alumne/a:</label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">
                                <div className="row">
                                  <div className="col col-3 ">
                                    <div
                                      className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="tipusDoc_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="tipusDoc" id="tipusDoc_LABEL"
                                          className="t-Form-label">Tipus document:</label>
                                      </div>
                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">

                                          <select id="tipusDoc" ref={tipusDocRef} defaultValue="DNI" name="tipusDoc" className="selectlist" size="1" onChange={(e) => setTipusDoc(e.target.value)}>
                                            <option value="DNI" short="DNI">DNI - Document Nacional d'Identitat </option>
                                            <option value="NIE" short="NIE">NIE - Número d'Identificació d'Estranger</option>
                                            <option value="PASS" short="Passaport">PASS - Passaport/Document d'un país de la comunitat Europea</option>
                                            { config.tipusDocTSI && (<option value="TSI" short="TSI">TSI - Targeta sanitària individual</option>) }
                                            { config.tipusDocPreInscripcio && (<option value="PRE" short="N.Preinscripció">PRE - N. Preinscripció</option>) }
                                          </select></div>
                                        <span className="a-Form-error">{errors.tipusDoc}</span>
                                      </div>
                                    </div>
                                  </div>


                                  <FormInputText id="iddocument" name="iddocument" col="col-3" label={"Número document "+getShortAttribute(tipusDocRef,tipusDoc)} obligatori={true} size="20" maxLength="20" value={iddocument} onBlur={handleBlurIDDocument} onChange={setIDDocument} error={ [errors.iddocument,errorValidacioIDdocument].join(' ').trim() } />

                                  { tipusDoc !== "PRE" && (
                                    <>
                                      <DropZone id="iddocumentFrontFile" file={iddocumentFrontFile} col="col-2" onChange={setIDDocumentFrontFile} label={"Adjuntar document "+getShortAttribute(tipusDocRef,tipusDoc)+"*"} labelSmall="(cara davant)" labelDrop={"adjuntar imatge "+getShortAttribute(tipusDocRef,tipusDoc)} error={errors.iddocumentFrontFile} handleFileError={(msg) => handleFileError('iddocumentFrontFile', msg)} />

                                      <DropZone id="iddocumentBackFile" file={iddocumentBackFile} col="col-2" onChange={setIDDocumentBackFile} label={"Adjuntar document "+getShortAttribute(tipusDocRef,tipusDoc)+"*"} labelSmall="(cara darrera)" labelDrop={"adjuntar imatge "+getShortAttribute(tipusDocRef,tipusDoc)} error={errors.iddocumentBackFile} handleFileError={(msg) => handleFileError('iddocumentBackFile', msg)} />
                                    </>
                                  )}

                                 { config.fotoCarnet && (<DropZone id="fotoCarnetFile" file={fotoCarnetFile} col="col-2" onChange={setFotoCarnetFile} label="Adjuntar foto mida carnet*" labelSmall="" labelDrop="adjuntar imatge" error={errors.fotoCarnetFile} handleFileError={ (msg) =>handleFileError('fotoCarnetFile',msg) } />)}

                                </div>
                              </div>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>

                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding margin-top-sm">


                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">

                                <div className="row">

                                  <FormInputText id="nom" name="nom" col="col-3" label="Nom" value={nom} obligatori={true} size="30" maxLength="50" onChange={setNom} valida={validaNom} error={errors.nom} />

                                  <FormInputText id="cognom1" name="cognom1" col="col-3" label="Primer cognom" value={cognom1} obligatori={true} size="30" maxLength="50" onChange={setCognom1} valida={validaCognom1} error={errors.cognom1} />

                                  <FormInputText id="cognom2" name="cognom2" col="col-3" label="Segon cognom" value={cognom2} obligatori={false} size="30" maxLength="50" onChange={setCognom2} error={errors.cognom2} />

                                  <div className="col col-1 ">
                                    <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="sexe_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="sexe" id="sexe_LABEL" className="t-Form-label">Sexe: </label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>

                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <select id="sexe" name="sexe" defaultValue={sexe} className="selectlist" size="1" onChange={(e) => setSexe(e.target.value)}>
                                            <option value=""></option>
                                            <option value="D" >Dona</option>
                                            <option value="H" >Home</option>
                                            { config.sexeNoBinari && (<option value="NB" >No-binari</option>)}
                                          </select></div>
                                        <span id="sexe_ERROR" className="a-Form-error">{errors.sexe}</span>
                                      </div>
                                    </div>
                                  </div>


                                  <div className="col col-2 ">
                                    <div id="dataNaixement" className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="dataNaixement" id="dataNaixement_LABEL" className="t-Form-label">Data Naixement (d/m/a): </label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>

                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <DateSelector selected={dataNaixement} onChange={setDataNaixement} minDate={minDate} maxDate={maxDate} />
                                        </div>

                                        <span id="dataNaixement_ERROR" className="a-Form-error">{errors.dataNaixement}</span>
                                      </div>
                                    </div>
                                  </div>

                                </div>

                                <div className="row">

                                  <FormInputText id="telefonmobil" name="telefonmobil" col="col-3" label="Telèfon mòbil alumne/a" value={telefonMobil} obligatori={majorEdat} size="10" maxLength="10" onChange={handleTelefonMobil} error={errors.telefon} />
                                  {/*<FormInputText id="telefonfix" name="telefonfix" col="col-3" label="Telèfon fix alumne/a" value={telefonFix} obligatori={true || telefonFixObligatori} size="10" maxLength="10" onChange={handleTelefonFix} error={errors.telefon} />*/}
                                  <FormInputText id="email" name="email" col="col-3" label="Email alumne/a" value={email} obligatori={false} size="10" maxLength="50" onChange={setEmail} error={errors.email} />
                                </div>

                                <div className="row">

                                  <div className="col col-1 ">
                                    <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="via_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="adrecaVia" id="via_LABEL" className="t-Form-label">Via: </label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>

                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <select id="adrecaVia" name="adrecaVia" defaultValue={adrecaVia} className="selectlist" size="1" onChange={(e) => setAdrecaVia(e.target.value)}>
                                            <option value="Avinguda">Avinguda</option>
                                            <option value="Carrer">Carrer</option>
                                            <option value="Plaça">Plaça</option>
                                            <option value="Passeig">Passeig</option>
                                            <option value="Carretera">Carretera</option>
                                            <option value="Rambla">Rambla</option>
                                            <option value="Via">Via</option>
                                          </select></div>
                                        <span id="adrecaVia_error" className="a-Form-error">{errors.adrecaVia}</span>
                                      </div>
                                  </div>
                                  </div>

                                  <FormInputText id="adrecaNom" name="adrecaNom" col="col-4" label="Nom de la via" value={adrecaNom} obligatori={true} size="30" maxLength="50" onChange={setAdrecaNom} error={errors.adrecaNom} />
                                  <FormInputText id="adrecaBloc" name="adrecaBloc" col="col-1" label="Bloc" value={adrecaBloc} obligatori={false} size="3" maxLength="5" onChange={setAdrecaBloc} error={errors.adrecaBloc} />
                                  <FormInputText id="adrecaNumero" name="adrecaNumero" col="col-1" label="Número" value={adrecaNumero} obligatori={true} size="3" maxLength="5" onChange={setAdrecaNumero} error={errors.adrecaNumero} />
                                  <FormInputText id="adrecaEscala" name="adrecaEscala" col="col-1" label="Escala" value={adrecaEscala} obligatori={false} size="5" maxLength="5" onChange={setAdrecaEscala} error={errors.adrecaEscala} />
                                  <FormInputText id="adrecaPlanta" name="adrecaPlanta" col="col-1" label="Planta" value={adrecaPlanta} obligatori={false} size="7" maxLength="7" onChange={setAdrecaPlanta} error={errors.adrecaPlanta} />
                                  <FormInputText id="adrecaPorta" name="adrecaPorta" col="col-1" label="Porta" value={adrecaPorta} obligatori={false} size="3" maxLength="5" onChange={setAdrecaPorta} error={errors.adrecaPorta} />

                                  <FormInputText id="codipostal" name="codipostal" col="col-1" label="Codi postal" value={codiPostal} obligatori={true} size="10" maxLength="10" onChange={setCodiPostal} error={errors.codiPostal} />

                                </div>
                                <div className="row">

                                  <FormInputText id="poblacio" name="poblacio" col="col-3" label="Municipi" value={poblacio} obligatori={true} size="20" maxLength="50" onChange={setPoblacio} error={errors.poblacio} />
                                  <FormInputText id="provincia" name="provincia" col="col-3" label="Provincia" value={provincia} obligatori={true} size="10" maxLength="10" onChange={setProvincia} error={errors.provincia} />
                                  <FormInputText id="pais" name="pais" col="col-3" label="País" value={pais} obligatori={true} size="10" maxLength="10" onChange={setPais} error={errors.pais} />

                                </div>


                                <div className="row">

                                  {majorEdat === true && (
                                  <React.Fragment>

                                    <FormSelectYesNo id="autoritzoComunicacioProgenitors"
                                      name="autoritzoComunicacioProgenitors"
                                      col="col-5"
                                      value={comunicacioProgenitors}
                                      label="Autoritzo que els meus progenitors/tutors legals puguin rebre comunicats de l’institut."
                                      obligatori={true}
                                      error={errors.comunicacioProgenitors}
                                      handleChange={(e) => setComunicacioProgenitors(e.target.value)} />


                                    {/*
                                    <ContacteEmergencia col="col-4"
                                      label="Telèfon en cas d'emergència"
                                      values={{ nom: contacteEmergenciaNom, relacio: contacteEmergenciaRelacio, telefon: contacteEmergenciaTelefon }}
                                      onChanges={{ nom: setContacteEmergenciaNom, relacio: setContacteEmergenciaRelacio, telefon: setContacteEmergenciaTelefon }}
                                      obligatori={ config.contacteEmergenciaObligatori && majorEdat }
                                      errors={errors} />
                                      */}

                                  </React.Fragment>)
                                  }

                                  {majorEdat === false &&

                                    (<React.Fragment>
                                      <DropZone id="llibreFamiliaFile" file={llibreFamiliaFile} onChange={setLlibreFamiliaFile} label="Llibre de família" labelSmall="(plana de progenitors)" labelDrop="adjuntar imatge" error={errors.llibreFamiliaFile} obligatori={true}  handleFileError={ (msg) =>handleFileError('llibreFamiliaFile',msg) }  />

                                      <DropZone id="llibreFamiliaAlumneFile" file={llibreFamiliaAlumneFile} onChange={setLlibreFamiliaAlumneFile} label="Llibre de família" labelSmall="(plana de l'alumne/a)" labelDrop="adjuntar imatge" error={errors.llibreFamiliaAlumneFile} obligatori={true} handleFileError={ (msg) =>handleFileError('llibreFamiliaAlumneFile',msg) }  />
                                      <div className="col col-3"><small>En cas de alumnat estranger sense llibre de família, adjuntar documentació pertinent.</small></div>

                                    <div className="row">
                                      <div className="col col-12" >
                                        &nbsp;
                                      </div>
                                    </div>


                                      <div className="row">
                                        <div className="col col-12" >
                                          <div className="t-Form-labelContainer">
                                            <label id="progenitor1Nom_LABEL" htmlFor="progenitor1Nom" className="t-Form-label">Dades dels progenitors / Tutors legals</label>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="row">

                                        <div className="col col-12" >

                                          <div className="col col-4">
                                            <div className="t-Form-labelContainer">
                                              <label id="progenitor1Nom_LABEL" className="t-Form-label">Tutor legal/Progenitor 1*</label>
                                            </div>

                                            <br/>

                                            <div className="col col-4 ">
                                              <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="progenitor1PM_CONTAINER">
                                                <div className="t-Form-labelContainer">
                                                  <label htmlFor="progenitor1PM" id="progenitor1PM_LABEL" className="t-Form-label">Progenitor: </label>
                                                  <span className="t-Form-required">
                                                    <span className="a-Icon">*</span>
                                                  </span>
                                                </div>

                                                <div className="t-Form-inputContainer">
                                                  <div className="t-Form-itemWrapper">
                                                    <select id="progenitor1PM" name="progenitor1PM" defaultValue={progenitor1PM} className="selectlist" size="1" onChange={(e) => setProgenitor1PM(e.target.value)}>
                                                      <option value=""></option>
                                                      <option value="M" >Mare</option>
                                                      <option value="P" >Pare</option>
                                                    </select></div>
                                                  <span id="progenitor1PM_ERROR" className="a-Form-error">{errors.progenitor1PM}</span>
                                                </div>
                                              </div>
                                            </div>

                                            <FormInputText id="progenitor1Nom" name="progenitor1Nom" col="col-12" label="Nom i cognoms" value={progenitor1Nom} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Nom} error={errors.progenitor1Nom} />
                                            <FormInputText id="progenitor1Adreca" name="progenitor1Adreca" col="col-12" label="Adreça" value={progenitor1Adreca} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Adreca} error={errors.progenitor1Adreca} />

                                            <FormInputText id="progenitor1Municipi" name="progenitor1Municipi" col="col-10" label="Municipi" value={progenitor1Municipi} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Municipi} error={errors.progenitor1Municipi} />
                                            <FormInputText id="progenitor1CodiPostal" name="progenitor1CodiPostal" col="col-4" label="Codi Postal" value={progenitor1CodiPostal} obligatori={true} size="8" maxLength="50" onChange={setProgenitor1CodiPostal} error={errors.progenitor1CodiPostal} />
                                            <FormInputText id="progenitor1Provincia" name="progenitor1Provincia" col="col-8" label="Provincia" value={progenitor1Provincia} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Provincia} error={errors.progenitor1Provincia} />
                                            <FormInputText id="progenitor1Pais" name="progenitor1Pais" col="col-8" label="País" value={progenitor1Pais} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Pais} error={errors.progenitor1Pais} />

                                            <FormInputText id="progenitor1iddocument" name="progenitor1iddocument" col="col-6" label="DNI/NIE/Passaport" value={progenitor1iddocument} obligatori={true} size="20" maxLength="20" onChange={setProgenitor1iddocument} error={errors.progenitor1iddocument} />
                                             <div className="col col-12"></div>
                                            <DropZone id="progenitor1IDFrontFile" file={progenitor1IDFrontFile} onChange={setProgenitor1IDFrontFile} label="DNI/NIE/Passaport (davant)*" labelDrop="adjuntar imatge" error={errors.progenitor1IDFrontFile}  handleFileError={ (msg) =>handleFileError('progenitor1IDFrontFile',msg) } />
                                            <DropZone id="progenitor1IDBackFile" file={progenitor1IDBackFile} onChange={setProgenitor1IDBackFile} label="DNI/NIE/Passaport (darrere)*" labelDrop="adjuntar imatge" error={errors.progenitor1IDBackFile}  handleFileError={ (msg) =>handleFileError('progenitor1IDBackFile',msg) } />
                                            <FormInputText id="progenitor1Telefon" name="progenitor1Telefon" col="col-12" label="Telèfon" value={progenitor1Telefon} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Telefon} error={errors.progenitor1Telefon} />
                                            <FormInputText id="progenitor1Email" name="progenitor1Email" col="col-12" label="E-mail" value={progenitor1Email} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Email} error={errors.progenitor1Email} />
                                            {/*<FormTextArea id="progenitor1Observacions" name="progenitor1Observacions" label="Horari de contacte / Observacions" value={progenitor1Observacions} obligatori={true} rows="5" cols="80" maxLength="1000" onChange={setProgenitor1Observacions} error={errors.progenitor1Observacions} />*/}
                                          </div>

                                          <div className="col col-4">
                                            <div className="t-Form-labelContainer">
                                              <label id="progenitor2Nom_LABEL" htmlFor="progenitor2Nom" className="t-Form-label">Tutor legal/Progenitor 2</label>
                                            </div>

                                            <br/>

                                            <div className="col col-4 ">
                                              <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="progenitor2PM_CONTAINER">
                                                <div className="t-Form-labelContainer">
                                                  <label htmlFor="progenitor2PM" id="progenitor2PM_LABEL" className="t-Form-label">Progenitor: </label>
                                                </div>

                                                <div className="t-Form-inputContainer">
                                                  <div className="t-Form-itemWrapper">
                                                    <select id="progenitor2PM" name="progenitor2PM" defaultValue={progenitor2PM} className="selectlist" size="1" onChange={(e) => setProgenitor2PM(e.target.value)}>
                                                      <option value=""></option>
                                                      <option value="M" >Mare</option>
                                                      <option value="P" >Pare</option>
                                                    </select></div>
                                                  <span id="progenitor2PM_ERROR" className="a-Form-error">{errors.progenitor2PM}</span>
                                                </div>
                                              </div>
                                            </div>

                                            <FormInputText id="progenitor2Nom" name="progenitor2Nom" col="col-12" label="Nom i cognoms" value={progenitor2Nom} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Nom} error={errors.progenitor2Nom} />
                                            <FormInputText id="progenitor2Adreca" name="progenitor2Adreca" col="col-12" label="Adreça" value={progenitor2Adreca} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Adreca} error={errors.progenitor2Adreca} />

                                            <FormInputText id="progenitor2Municipi" name="progenitor2Municipi" col="col-10" label="Municipi" value={progenitor2Municipi} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Municipi} error={errors.progenitor2Municipi} />
                                            <FormInputText id="progenitor2CodiPostal" name="progenitor2CodiPostal" col="col-4" label="Codi Postal" value={progenitor2CodiPostal} obligatori={false} size="8" maxLength="50" onChange={setProgenitor2CodiPostal} error={errors.progenitor2CodiPostal} />
                                            <FormInputText id="progenitor2Provincia" name="progenitor2Provincia" col="col-8" label="Provincia" value={progenitor2Provincia} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Provincia} error={errors.progenitor2Provincia} />
                                            <FormInputText id="progenitor2Pais" name="progenitor2Pais" col="col-8" label="País" value={progenitor2Pais} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Pais} error={errors.progenitor2Pais} />

                                            <FormInputText id="progenitor2iddocument" name="progenitor2iddocument" col="col-6" label="DNI/NIE/Passaport" value={progenitor2iddocument} obligatori={false} size="20" maxLength="20" onChange={setProgenitor2iddocument} error={errors.progenitor2iddocument} />
                                             <div className="col col-12"></div>
                                            <DropZone id="progenitor2IDFrontFile" file={progenitor2IDFrontFile} onChange={setProgenitor2IDFrontFile} label="DNI/NIE/Passaport (davant)" labelDrop="adjuntar imatge" error={errors.progenitor2IDFrontFile}  handleFileError={ (msg) =>handleFileError('progenitor2IDFrontFile',msg) }  />
                                            <DropZone id="progenitor2IDBackFile" file={progenitor2IDBackFile} onChange={setProgenitor2IDBackFile} label="DNI/NIE/Passaport (darrere)" labelDrop="adjuntar imatge" error={errors.progenitor2IDBackFile}  handleFileError={ (msg) =>handleFileError('progenitor2IDBackFile',msg) }  />
                                            <FormInputText id="progenitor2Telefon" name="progenitor2Telefon" col="col-12" label="Telèfon" value={progenitor2Telefon} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Telefon} error={errors.progenitor2Telefon} />
                                            <FormInputText id="progenitor2Email" name="progenitor2Email" col="col-12" label="E-mail" value={progenitor2Email} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Email} error={errors.progenitor2Email} />
                                            {/*<FormTextArea id="progenitor2Observacions" name="progenitor2Observacions" label="Horari de contacte / Observacions" value={progenitor2Observacions} obligatori={false} rows="5" cols="80" maxLength="1000" onChange={setProgenitor2Observacions} error={errors.progenitor2Observacions} />*/}

                                          </div>


                                          {/*
                                          <ContacteEmergencia col="col-4"
                                            label="Telèfon en cas d'emergència"
                                            values={{ nom: contacteEmergenciaNom, relacio: contacteEmergenciaRelacio, telefon: contacteEmergenciaTelefon }}
                                            onChanges={{ nom: setContacteEmergenciaNom, relacio: setContacteEmergenciaRelacio, telefon: setContacteEmergenciaTelefon }}
                                            errors={errors} />
                                          */}

                                        </div>

                                      </div>
                                    </React.Fragment>)}

                                </div>

                                    <div className="row">
                                      <div className="col col-12" >
                                        &nbsp;
                                      </div>
                                    </div>


                                { config.necessitatsEducativesEspecials && (<div className="row">
                                  <DropZone id="necessitatsEducativesEspecialsFile" file={necessitatsEducativesEspecialsFile} col="col-3" onChange={setNecessitatsEducativesEspecialsFile} label="Adjuntar qualsevol documentació/informe rellevant per a l'escolarització del seu fill/a:" labelSmall="" labelDrop="Adjuntar document" error={errors.necessitatsEducativesEspecialsFile} handleFileError={ (msg) =>handleFileError('necessitatsEducativesEspecialsFile',msg) } />
                                  <FormTextArea id="necessitatsEducativesEspecialsObservacions" name="necessitatsEducativesEspecialsObservacions" label="Observacions" value={necessitatsEducativesEspecialsObservacions} obligatori={false} rows="5" cols="80" maxLength="1000" onChange={setNecessitatsEducativesEspecialsObservacions} error={errors.necessitatsEducativesEspecialsObservacions} />
                                </div>) }

                              </div>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>

                  <div className="container">
                    <div className="row">
                      <div className="col col-12" align="center">
                        { 
                          /* si cal validar documents deshabilitem botó continuar fins assegurar que està validat correctament */
                        
                        ((config.validaIDdocuments && ( errorValidacioIDdocument === null || errorValidacioIDdocument === "")  ) 
                        || !config.validaIDdocuments ) ?
                        (<button onClick={valida} className="button">SEGÜENT</button>)
                        :
                        (<button className="button" disabled>SEGÜENT</button>)}
                      </div>
                    </div>
                  </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}